import React from 'react';
import PropTypes from 'prop-types';
import serialize from 'serialize-javascript';
import config from 'config';
import Script from '../Script';
/**
 * Render a JavaScript snippet that loads Site24x7 RUM.
 */

export default function Site24x7RUMSnippet(_ref) {
  var _ref$appKey = _ref.appKey,
      appKey = _ref$appKey === void 0 ? config.get('public.site24x7.rum.appKey') : _ref$appKey;
  var appKeyString = encodeURIComponent(appKey);
  return /*#__PURE__*/React.createElement(Script, {
    globalScriptKey: ['site24x7rum', appKey],
    dangerouslySetInnerHTML: {
      __html: "\n(function(w,d,s,r,k,h,m){\nif(w.performance&&w.performance.timing&&w.performance.navigation)\n{w[r]=w[r]||function(){(w[r].q=w[r].q||[]).push(arguments)}\nh=d.createElement('script');h.async=true;h.setAttribute('src',s+k);\nd.getElementsByTagName('head')[0].appendChild(h);\n(m=window.onerror),(window.onerror=function(b,c,d,f,g)\n{m&&m(b,c,d,f,g),g||(g=new Error(b)),(w[r].q=w[r].q||[]).push([\"captureException\",g]);})}\n})(window,document,'//static.site24x7rum.com/beacon/site24x7rum-min.js?appKey=','s247r',".concat(serialize(appKeyString), ");\n")
    }
  });
}
Site24x7RUMSnippet.propTypes = {
  /**
   * If not provided, it will attempt to use the `public.site24x7.rum.appKey`
   * config option.
   */
  appKey: PropTypes.string
};